<template>
  <scpm-accordion-item
    ref="AccordionItem"
    :title="title"
    :expand="isExpand"
    :index="isExpand ? 0 : 1"
    expandable
    class="scpm-sub-tree-v3"
    @clickSub="clickSub"
  >
    <template #title>
      <slot name="title">
        <div class="lego-tree-dropdown__title">
          <span class="title-sub">
            <span>{{ title }}</span>
          </span>
        </div>
      </slot>
    </template>

    <template #expand>
      <div
        class="lego-dropdown__item"
        :class="{
          'lego-dropdown__item--active': isActive(product)
        }"
        v-for="(product, idx) in items"
        @click.stop="clickItem({ ...product, item })"
        :key="idx"
      >
        <div
          class="lego-dropdown__label"
          :class="{ 'lego-dropdown__selected': isActive(product) }"
          :id="`dropdown-child-${product.typeOrder}`"
        >
          <span v-lego-tooltip:ellipsis="product.text" class="ellipsis">
            {{ product.text }}
          </span>
        </div>
      </div>
    </template>
  </scpm-accordion-item>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import scpmSubTree from './ScpmSubTreeDropdown.vue';

export default {
  mixins: [i18nMixin, scpmSubTree],
  name: 'scpm-sub-tree-dropdown-v3',

  methods: {
    clickSub() {
      // this.items[0].item = {};
      // this.items[0].item.icon = this.item.icon;
      // this.$emit('click', this.items[0]);
      this.$refs['AccordionItem'].isExpend = !this.$refs['AccordionItem'].isExpend;
      this.$emit('click', { expend: 'true' });
    }
  }
};
</script>

<style lang="scss" scoped>
.scpm-sub-tree-v3 {
  width: 100%;

  :deep .accordion-list-item__main {
    padding-left: 0px !important;
    border-radius: 4px;
  }

  .lego-dropdown__item:hover {
    background-color: #eef2fc;
    border-radius: 4px;
  }

  :deep .accordion-list-item__expand {
    .lego-dropdown__item {
      padding-left: 51px !important;
      padding: 2px 10px 2px 10px;
    }

    .lego-dropdown__item--active {
      background-color: #e1e7f9;
      border-radius: 4px;
    }
  }
}
</style>
